import {
  LOAD_USERS,
  LOAD_LEVELS,
  LOAD_USER_BY_ID,
  UPDATE_USER_PHOTO_THUMB,
  LOAD_USER_BY_ID_FOR_PROFILE,
  ADD_USER,
  ADD_USER_WITH_SHOP,
  UPDATE_USER_BY_ID,
  REMOVE_USER_BY_ID,
  UNSET_CURRENT_USER,
  LOAD_USERS_FAILED,
  ADD_USER_FAILED,
  REMOVE_ADD_USER_FAILED,
  UPDATE_PERMISSIONS
} from '../../actions/users';
import { mergeDeepLeft, clone } from 'ramda';

function converType(id) {
  const types = [
    {
      value: 1,
      text: 'Administrator',
    },
    {
      value: 2,
      text: 'Business Manager',
    },
    {
      value: 3,
      text: 'Sales Person',
    },
    {
      value: 4,
      text: 'Worker',
    },
    {
      value: 5,
      text: 'Client',
    },
  ];

  for (let i = types.length; i--;) {
    if (types[i].value == id) {
      return types[i].text;
    }
  }

  return null;
}

export default function users(state = {}, action) {
  switch (action.type) {
    case LOAD_USERS:
      return Object.assign({}, mergeDeepLeft(state, action.payload));
    case LOAD_LEVELS:
      return Object.assign({}, state, action.payload);
    case LOAD_USER_BY_ID:
      return Object.assign({}, state, action.payload);
    case UPDATE_USER_PHOTO_THUMB:
      var currentUser = {...state.currentUser, photoThumb: action.payload};
      return Object.assign({}, state, { currentUser });
    case LOAD_USER_BY_ID_FOR_PROFILE:
      return Object.assign({}, state, action.payload);
    case ADD_USER:
      return Object.assign({}, state, action.payload);
    case ADD_USER_WITH_SHOP:
      return Object.assign({}, state, action.payload);
    case UPDATE_USER_BY_ID:
      for (let i = 0; i < state.userList.length; i++) {
        if (state.userList[i].id == action.payload.id) {
          state.userList[i].email = action.payload.data.email;
          state.userList[i].firstname = action.payload.data.firstname;
          state.userList[i].lastname = action.payload.data.lastname;
          state.userList[i].type = converType(action.payload.data.user_level_id);
          state.userList[i].username = action.payload.data.username;
        }
      }
      return Object.assign({}, state, action.payload);
    case REMOVE_USER_BY_ID:
      for (let i = 0; i < state.userList.length; i++) {
        if (state.userList[i].id == action.payload.id) {
          state.userList.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case UNSET_CURRENT_USER:
      return Object.assign({}, state, action.payload);
    case LOAD_USERS_FAILED:
      return Object.assign({}, state, action.payload);
    case ADD_USER_FAILED:
      return Object.assign({}, state, action.payload);
    case REMOVE_ADD_USER_FAILED:
      return Object.assign({}, state, action.payload);
    case UPDATE_PERMISSIONS:
      const { permission, roleId } = action.payload;
      if (state.userProfile.roleId == roleId) {
        state.userProfile.permission = permission;
      }
      return Object.assign({}, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users/index.js